import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/sad-cry': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM392 394.4c34.6-35.9 56-84.7 56-138.4 0-110.3-89.7-200-200-200s-200 89.7-200 200c0 53.7 21.4 102.4 56 138.4v-114.4c0-13.2 10.8-24 24-24s24 10.8 24 24v151.4c28.5 15.6 61.2 24.6 96 24.6s67.5-9 96-24.6v-151.4c0-13.2 10.8-24 24-24s24 10.8 24 24v114.4zM205.8 234.5c-5.8 3.2-11.2 0.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0l-9.5 8.5c-3.8 3.4-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 3.9-25.2 34.2-42.1 59.8-42.1 25.6 0 55.8 16.9 59.8 42.1 0.8 5-1.7 10-6.1 12.4zM344 180c25.7 0 55.9 16.9 59.8 42.1 0.8 5-1.7 10-6.1 12.4-5.7 3.1-11.2 0.6-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0l-9.5 8.5c-3.8 3.4-9.2 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 3.9-25.2 34.1-42.1 59.8-42.1zM248 272c30.9 0 56 28.7 56 64s-25.1 64-56 64-56-28.7-56-64 25.1-64 56-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/sad-cry.js
// module id = 1811
// module chunks = 0